import { TextField, InputAdornment, CircularProgress, FormControl } from '@mui/material';
import { useInputStore } from 'Store';
import { useState } from 'react';


const validateEmail = (email) => {
    // Regular expression for validating an Email
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

export const Email = () => {
    const email = useInputStore(state => state.email);
    const setValue = useInputStore((state) => state.set_value);

    const [error, setError] = useState(false);
    const [timerId, setTimerId] = useState(null);

    const handleChange = (event) => {
        const value = event.target.value;
        setValue({ "email": value });
        if (timerId) {
            clearTimeout(timerId);
            setTimerId(null);
        }
        if (value === "") {
            setError(false);
            clearTimeout(timerId);
            return;
        }   
        const newTimerId = setTimeout(() => {
            const valid = validateEmail(value);
            setError(!valid);
            setTimerId(null);
        }, 1500); 
        setTimerId(newTimerId);
    };

    return (
        <FormControl fullWidth>
       
        <TextField
            labelId="email"
            size="small"
            label="Email"
            value={email}
            onChange={handleChange}
            error={error}
            helperText={error ? "Invalid Email" : ""}
            InputProps={{
                endAdornment: timerId && (
                    <InputAdornment position="end">
                        <CircularProgress size={20} />
                    </InputAdornment>
                ),
            }}
        />
        </FormControl>
    );
};

